<div class="pdf-page app-aul-038-24" id="aul03824">
    <p class="font-large" style="text-align: center">
       <b> CONDOMINIUM COVERAGE EXTENSION ENDORSEMENT </b>
    </p>
    <p class="font-large" style="text-align: center">
        <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY </b>
    </p>
    <br />
    <p class="font-small">
        This endorsement modifies insurance provided under the following:
        <br />
            <b>
                CONDOMINIUM ASSOCIATION COVERAGE FORM  
            </b><br>
            <b>
                CAUSES OF LOSS – SPECIAL FORM 
            </b>
    </p>
 
    <ol type="A" start="1">
    <li>
        Under <b>CONDOMINIUM ASSOCIATION COVERAGE FORM</b> Section <b>A. Coverage.</b> Paragraph <b>4. Additional Coverages.</b> The following subparagraph <b>g. Unscheduled Business Personal Property</b> is added as follows: 
        
        <ol style="padding-left: 35px;" type="a" start="7">
            <br>
            <li>
                <b>Unscheduled Business Personal Property </b><br>
                We will pay for direct physical loss or damage to your unscheduled business personal property located in or on the building in the open (or in a vehicle) within 100 ft of the described premises caused by or resulting from any Covered cause of loss. 
            </li>
        </ol>
        <p>This additional coverage does not include any property covered under Section 1b Business Personal Property. </p>
        <p>The most we will pay under the Additional Coverage is $25,000 in any one occurrence. </p>
    </li>
    <li>
        Under <b>CONDOMINIUM ASSOCIATION COVERAGE FORM</b> Section <b>A. Coverage.</b> Paragraph <b>5. Coverage Extensions.</b> The following subparagraph <b>h. Loss of Condominium Association Fees</b> is added as follows:    
          
        <ol style="padding-left: 35px;" type="a" start="8">
            <br/>
            <li>
                <b>Loss of Condominium Association Fees</b><br>
                The insurance provided by this Coverage Form is extended to apply to loss of “condominium association fees” sustained by you resulting directly form the necessary untenantability of any unit, during the “period of restoration”, caused by direct physical loss or damage to Covered Property by a Covered Cause of Loss. However, the loss of “condominium association fees” does not include “loss assessment charges”.         
            </li>     
        </ol>  
        <p>As used in this subparagraph 5.h., these terms are defined as follows: </p>
        <!-- <ol type="1" style="padding-left: 35px;"> -->
            <ul style="list-style-type: none">
                <li>
                    (1)    “Condominium association fees” means fees payable to you in accordance with the 
                    condominium association agreement between you and a unit owner, and in accordance with the terms of your association by laws. 
                </li>
                <li>
                    (2)    “Loss assessment charges” mean assessments charged to all unit owners, by the 
                    Condominium Association, due to additional costs incurred by the association as a result of physical loss or damage to Covered property. 
                </li>
                <li>
                    (3)    “Period of restoration” means the period of time that: 
                    <ul style="list-style-type: none">
                        <li>
                            a.  Begins on the date of direct physical loss or damage to Covered Property by a Covered Cause of Loss; and 
                        </li>
                        <li >
                            b.  Ends on the date when covered property should be repaired, rebuilt or replaced with reasonable speed and similar quality.
                        </li>
                        
                    </ul>
                </li>              
        </ul>
        <p>The most we will pay under this Coverage Extension is $50,000 in any one occurrence.  </p>
      </li>
<li>  
    <p>Under <b>CAUSES OF LOSS – SPECIAL FORM</b> Section <b>C. Limitations.</b> Paragraph 1. c. Is deleted and replaced by the following:  </p>
    <ul style="list-style-type: none">
        <li>
            c. 	 The interior of any building or structure, or to personal property in the building or structure, caused by or resulting from rain, snow, sleet, ice, sand or dust, whether driven by wind or not, unless:               
            <ul style="list-style-type: none">
                <li>
                    (1)    The building or structure first sustains damage by a Covered Cause of Loss to its roof or walls through which the rain, snow, sleet, ice, sand or dust enters; or 
                </li>
                <li>
                    (2)    The loss or damage is caused by or results from thawing of snow, sleet or ice on the building or structure.
                </li>
            </ul>
        </li>
    </ul> 
    <p>However, if this policy covers the peril of Wind, this limitation does not apply to loss or damage caused by <b>wind driven rain.</b> </p>
    <p>The most we will pay for loss or damage caused by <b>wind driven rain</b>, which is sustained without damage to the building or structure by a Covered Cause of Loss, is $25,000 in any one occurrence.  </p>
</li>
<li>
    <b>The coverage provided by this endorsement; </b>
    <ol type="1" start="1">
        <li>
            Applies to the Covered Premises described in the Commercial Property Supplemental Declarations, “Declarations”;  
        </li>
        <li>
            Is not subject to coinsurance; and 
        </li>
        <li>
            Does not increase the total limits of liability as shown in the Declarations. 
        </li>
        <li>
            Ends on the Policy expiration date shown on the Common Policy Declarations;  
        </li>
    </ol>
</li>
</ol>
</div>